export var WidgetViewerEvents;
(function (WidgetViewerEvents) {
    WidgetViewerEvents[WidgetViewerEvents["TIMETABLE_OPENED"] = 580] = "TIMETABLE_OPENED";
    WidgetViewerEvents[WidgetViewerEvents["TIMETABLE_NAVIGATION"] = 579] = "TIMETABLE_NAVIGATION";
    WidgetViewerEvents[WidgetViewerEvents["BOOK_BUTTON_CLICK"] = 501] = "BOOK_BUTTON_CLICK";
    WidgetViewerEvents[WidgetViewerEvents["PREMIUM_PREVENTION"] = 527] = "PREMIUM_PREVENTION";
    WidgetViewerEvents[WidgetViewerEvents["STAFF_LIST_LOADED"] = 540] = "STAFF_LIST_LOADED";
    WidgetViewerEvents[WidgetViewerEvents["STAFF_CLICKED"] = 501] = "STAFF_CLICKED";
})(WidgetViewerEvents || (WidgetViewerEvents = {}));
export var WidgetName;
(function (WidgetName) {
    WidgetName["DAILY_TIMETABLE"] = "daily_time_table";
    WidgetName["BOOK_BUTTON"] = "book_button";
    WidgetName["STAFF_LIST"] = "staff_list";
})(WidgetName || (WidgetName = {}));
export var TimetableDirection;
(function (TimetableDirection) {
    TimetableDirection["BACKWARD"] = "backward";
    TimetableDirection["FORWARD"] = "forward";
    TimetableDirection["NA"] = "day-pressed";
})(TimetableDirection || (TimetableDirection = {}));
export var TimetableNavigationType;
(function (TimetableNavigationType) {
    TimetableNavigationType["DAY"] = "day";
    TimetableNavigationType["WEEK"] = "week";
})(TimetableNavigationType || (TimetableNavigationType = {}));
export var TimetableClickType;
(function (TimetableClickType) {
    TimetableClickType["ARROW"] = "arrow";
    TimetableClickType["DATE"] = "date";
})(TimetableClickType || (TimetableClickType = {}));
export var TimetableActionType;
(function (TimetableActionType) {
    TimetableActionType["NAVIGATE_TO_BOOKING_FORM"] = "navigate_to_booking_form";
    TimetableActionType["NAVIGATE_TO_CONTACT_FORM"] = "navigate_to_contact_form";
    TimetableActionType["NAVIGATE_TO_SERVICE_PAGE"] = "navigate_to_service_page";
    TimetableActionType["OPEN_WAITING_LIST_MODAL"] = "open_waiting_list_modal";
    TimetableActionType["OPEN_UOU_PREMIUM_MODAL"] = "open_uou_premium_modal";
    TimetableActionType["OPEN_OWNER_PREMIUM_MODAL"] = "open_owner_premium_modal";
})(TimetableActionType || (TimetableActionType = {}));
export var BI_BOOKINGS_SRC = 16;
export var WidgetReferralInfo;
(function (WidgetReferralInfo) {
    WidgetReferralInfo["BOOK_BUTTON"] = "book_button_widget";
    WidgetReferralInfo["TIME_TABLE"] = "daily_time_table_widget";
    WidgetReferralInfo["STAFF_LIST"] = "staff_widget";
})(WidgetReferralInfo || (WidgetReferralInfo = {}));
export var WidgetActionName;
(function (WidgetActionName) {
    WidgetActionName["NAVIGATE_TO_SPECIFIC_PAGE"] = "navigate_to_specific_page";
    WidgetActionName["NAVIGATE_TO_SERVICES_LIST"] = "navigate_to_services_list";
})(WidgetActionName || (WidgetActionName = {}));
//# sourceMappingURL=bi.const.js.map